"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth0_react_1 = require("@auth0/auth0-react");
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const GlobalModal_1 = require("../../../common/js/components/GlobalModal");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const ScopeGuard_1 = __importDefault(require("../../../common/js/components/security/ScopeGuard"));
const AuthorizationScopes_1 = __importDefault(require("../../../common/js/enums/AuthorizationScopes"));
const ButtonSize_1 = __importDefault(require("../../../common/js/enums/ButtonSize"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const translation_1 = require("../../../common/js/helper/translation");
const withAuthorization_1 = __importDefault(require("../../../common/js/hoc/withAuthorization"));
const LocalStorageKeys_1 = __importDefault(require("../../enums/LocalStorageKeys"));
const address_1 = require("../../helper/address");
const addressesColumns_1 = require("../../helper/addressesColumns");
const MassiveCompany_1 = __importDefault(require("../../stores/MassiveCompany"));
const ChangeRequestModal_1 = __importDefault(require("../ChangeRequestModal"));
const MessageModal_1 = __importDefault(require("../MessageModal"));
const TableTile_1 = __importDefault(require("../TableTile"));
class UserProfileAddresses extends react_1.default.Component {
    componentDidMount() {
        document.title = (0, translation_1.t)('profile_subpage_title', { title: (0, translation_1.t)('user.profile.addresses.title') });
        MassiveCompany_1.default.loadCompany();
    }
    render() {
        if (MassiveCompany_1.default.isLoading) {
            return (react_1.default.createElement("section", { className: "znd-user-profile-page__table" },
                react_1.default.createElement(LoadingSpinner_1.default, { center: true })));
        }
        return (react_1.default.createElement("section", { className: "znd-user-profile-page__table" },
            react_1.default.createElement(TableTile_1.default, { columns: (0, addressesColumns_1.getAddressesColumns)(), data: this.getUserProfileAddresses(), header: this.getHeaderTable(), localStorageKey: LocalStorageKeys_1.default.addressesSort })));
    }
    getHeaderTable() {
        return (react_1.default.createElement("div", { className: "d-flex align-items-start justify-content-between znd-table-tile__header" },
            react_1.default.createElement("div", { className: "znd-table-tile__header-title t-card-title" }, (0, translation_1.t)('user.profile.addresses.title')),
            react_1.default.createElement(ScopeGuard_1.default, { scopes: [AuthorizationScopes_1.default.COMPANY_UPDATE, AuthorizationScopes_1.default.ADDRESS_CREATE] },
                react_1.default.createElement(Button_1.default, { className: 'znd-table-tile__header-button', variant: ButtonVariant_1.default.secondary, size: ButtonSize_1.default.small, text: (0, translation_1.t)('user.profile.addresses.add_address'), icon: Zupicons_1.default.plus, onClick: () => {
                        (0, GlobalModal_1.showModal)({
                            component: MessageModal_1.default,
                            props: {
                                title: (0, translation_1.t)('user.profile.addresses.add_address'),
                                body: (0, translation_1.t)('user.profile.addresses.edit_address.modal.confirm.text'),
                            },
                        }).then(() => {
                            (0, GlobalModal_1.showModal)({
                                component: ChangeRequestModal_1.default,
                                props: {
                                    title: (0, translation_1.t)('user.profile.addresses.add_address'),
                                    topic: ecommerce_1.ChangeRequestTopicEnum.Address,
                                    object: ecommerce_1.ChangeRequestObjectEnum.AddressAddress,
                                    data: {
                                        countryCode: MassiveCompany_1.default.company?.defaultMassiveAddress?.country?.iso,
                                    },
                                },
                            }).then(() => {
                                MassiveCompany_1.default.loadCompany();
                            });
                        });
                    } }))));
    }
    getUserProfileAddresses() {
        const addresses = (0, address_1.getAddressesOfCompany)(MassiveCompany_1.default.company);
        return Object.values(addresses);
    }
}
__decorate([
    bind_decorator_1.default
], UserProfileAddresses.prototype, "getUserProfileAddresses", null);
exports.default = (0, auth0_react_1.withAuth0)((0, withAuthorization_1.default)({ scopes: [AuthorizationScopes_1.default.COMPANY_READ, AuthorizationScopes_1.default.ADDRESS_READ] })((0, mobx_react_1.observer)(UserProfileAddresses)));
